import React from 'react';

const donationHeaderSpiritualBootCamp = ({ firstName = '' } = {}) => (
  <div>
    <h2
      style={{
        fontSize: '40px',
        textAlign: 'center',
        color: '#4a4a4a',
      }}
    >
      Great news {firstName}! Your "30-Day Spiritual Boot Camp" is on its way to your
      inbox.
    </h2>
    <br></br>
    <div>
      <p>
        We praise God for your heart to grow closer to Him, and we hope this
        devotional will help you be{' '}
        <em>
          “transformed by the renewal of your mind, that by testing you may
          discern what is the will of God”
        </em>{' '}
        (Romans 12:2, ESV).
      </p>
      <p
        style={{
          marginBottom: '1rem',
        }}
      >
        The Billy Graham Evangelistic Association is able to offer the hope of
        Jesus Christ through materials like this because of friends like you.
        The Lord is using the gifts and prayers of other believers to reach
        people across the globe with the Gospel—and there are so many more who
        need to hear the Good News of Jesus. If the Lord is leading you, you can
        be a part of this ministry by giving a secure donation today.
      </p>
      <a
        href="https://giving.billygraham.org/"
        className="button is-primary"
        target="_blank"
        rel="noreferrer"
      >
        <strong>Help Now</strong>
      </a>
    </div>
  </div>
);

export default donationHeaderSpiritualBootCamp;
